$(document).on("admin-tribes-edit:ready admin-tribes-new:ready", function () {
  var isFetchingData = false;
  if ($("#name-recorded").is(":visible")) {
    var recorded_name = true;
  }
  $("#speaker-icon").click(function () {
    document.getElementById("tribe-audio").play();
  });
  if (recorded_name != true) {
    $("#tribe-edit").toggle();
    $("#tribe-name-delete").toggle();
    $("#speaker-icon").toggle();
  }
  $(".recording").toggle();
  $("#tribe-re-record").toggle();
  $("#tribe-edit").click(function () {
    $(this).toggle();
    if ($("#speaker-icon").is(":visible")) {
      $("#speaker-icon").toggle();
    }
    $(".recording").toggle();
    $("#tribe-name-delete").toggle();
  });
  $("#tribe-record, #tribe-re-record").click(function () {
    $(this).toggle();
    $(".recording").toggle();
  });
  $("#tribe-name-delete").click(function () {
    if (confirm("Please update tribe to complete deletion.")) {
      $("#tribe_recorded_name").prop("checked", false);
      $(this).toggle();
      $("#tribe-edit").toggle();
      $("#tribe-re-record").toggle();
    }
  });
  $(".status-list-select").select2({ placeholder: "Select Status..." });
  $(".state-list-select").select2({ placeholder: "Select State(s)..." });
  $(".users-select").select2({ placeholder: "Select Admins..." });

  $(document).ready(function () {
    $("span.question").hover(
      function () {
        var ttcontent = $(this).data("tooltipcontent");
        $(this).append('<div class="tooltip"><p>' + ttcontent + "</p></div>");
      },
      function () {
        $("div.tooltip").remove();
      }
    );
  });
});
